export { SimpleTitleAndCta } from './SimpleTitleAndCta'
export type { SimpleTitleAndCtaProps } from './SimpleTitleAndCta'
